module.exports = __webpack_public_path__ + "static/media/logo_graa_pile.dba5c0ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/img/logo_graa_pile.png
// module id = 1487
// module chunks = 0